/**
 * 隐患依据
 */

import { get, post, del } from "@/util/request";
import download from "@/util/download";
/**
 * 分页获取隐患依据
 * @param {*} data
 * @returns
 */
export const GetDataHiddenTroubleList = (data) => {
  return post("/api/app/hiddenTrouble/list", data, {});
};

/**
 * 删除隐患依据
 * @param {*} data
 * @returns
 */
export const DeleteDataHiddenTrouble = (id) => {
  return del(`/api/app/hiddenTrouble/${id}`, {}, {});
};

/**
 * 获取详情
 * @param {*} data
 * @returns
 */
export const DetailDataHiddenTrouble = (troubleId) => {
  return get(`/api/app/hiddenTrouble/troubleDetail/${troubleId}`);
};

/**
 * 新增、修改保存隐患依据
 * @param {*} data
 * @returns
 */
export const saveHiddenTrouble = (data) => {
  return post("/api/app/hiddenTrouble/saveHiddenTrouble", data, {});
};

/**
 * 导出隐患依据
 * @param {*} data
 * @returns
 */
export const ExportDataHiddenTrouble = (data) => {
  let defaluturl = `/api/app/hiddenTrouble/exportExcelFile`;
  let fileName = "隐患依据"
  return download(fileName, defaluturl, data);
}

/* 批量删除 */
export const DeleteTroubles = (data) => {
  return post('/api/app/hiddenTrouble/delTroubles', data, {});
}
